import { FILTER_FORM_DEFAULT_VALUES } from '../../util/constants.js'

export default function () {
  return {
    connections: [],
    organisationConnections: [],
    organisations: [],
    reports: [],
    reportsStats: {},
    reportsYears: [],
    reportSelectedConnections: [],
    postSelectedConnections: [], // Could move this to careerwise/shared ?
    filterForm: {
      ...FILTER_FORM_DEFAULT_VALUES,
    },
  }
}
